export default __webpack_public_path__ + "static/media/linkedin-white.90497d72.svg";